import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { LearningTable } from '../LearningTabl';
import { GrupsBar } from './GrupsBar';

export const MainTableUiVersionTwo = ({ dateRange, hasFilter }) => {

    const { groups } = useSelector((state) => state.vrlSlice);
    const [grupSelected, setgrupSelected] = useState("all")

    return (
        <div className='w-full'>
            <p className='text-black pl-4 pt-4 font-semibold text-2xl'>Usuarios</p>
            <div className='w-full px-4 flex'>
                <GrupsBar groups={groups} grupSelected={grupSelected} setgrupSelected={setgrupSelected} ></GrupsBar>
            </div>
            <div className='px-4'>
                <LearningTable grupSelected={grupSelected} dateRange={dateRange} hasFilter={hasFilter} />
            </div>
        </div>
    )
}

